import React from 'react';
import { FaBuilding, FaCalendarAlt, FaBriefcase, FaMedal } from "react-icons/fa";
import { BiMap } from "react-icons/bi";

const Experience = () => {
    return (
        <>
            <div className='flex items-center text-xl font-bold'>
                <FaBriefcase className='w-6 h-6 mr-2 mb-2'/> Experience
            </div>
            <div className='ml-8'>
                <div className="flex items-center mb-2">
                    <FaBuilding className='w-4 h-4 mr-2'/> MTAB Technology Center Private Limited
                </div>
                <div className="flex items-center mb-2">
                    <FaCalendarAlt className='w-4 h-4 mr-2'/> Dec 2022 - Feb 2023
                </div>
                <div className="flex items-center mb-2">
                    <BiMap className='w-4 h-4 mr-2'/> Remote, Chennai, Tamil Nadu, India
                </div>
                <div className="flex items-center mb-2">
                    <FaBriefcase className='w-4 h-4 mr-2'/> Web Developer Intern
                </div>
                <div className="flex items-center mb-2">
                    <FaMedal className='w-4 h-4 mr-2'/> Achievements:
                </div>
                <ul className="list-disc list-inside ml-6 text-justify">
                    <li>Worked on the development of 3 websites, delivering a total of 22 unique outcomes with a focus on meeting project requirements.</li>
                    <li>Contributed to the planning, design, and development of a new product's webpage from scratch.</li>
                    <li>Collaborated with cross-functional teams, including designers, product managers, marketing professionals, and the CEO, to ensure the project's success.</li>
                </ul>
            </div>
        </>
    );
};

export default Experience;
